import { useLang } from "@/i18n";

export function LogoMark({ size = 40 }) {
  return (
    <img
      src="/assets/brand/logo-was.png"
      alt="World Aviation Services logo"
      style={{ height: size, width: "auto" }}
      data-testid="logo-mark"
    />
  );
}

export function Logo({ compact = false }) {
  const { t, isAr } = useLang();
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark size={compact ? 30 : 38} />
      <div className="leading-tight">
        <div className="font-extrabold text-white text-sm sm:text-base tracking-tight">{t("brand")}</div>
        <div className="font-mono-tag text-[10px] tracking-[0.22em] text-blue-400 uppercase">
          {isAr ? "WAS · WORLD-WAS.LY" : "شركة العالم · WORLD-WAS.LY"}
        </div>
      </div>
    </div>
  );
}
